import { render, staticRenderFns } from "./NotificationElement.vue?vue&type=template&id=65e11cf6&scoped=true&"
import script from "./NotificationElement.vue?vue&type=script&lang=js&"
export * from "./NotificationElement.vue?vue&type=script&lang=js&"
import style0 from "./NotificationElement.vue?vue&type=style&index=0&id=65e11cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e11cf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileActionText } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDivider,
  VIcon,
  VListTile,
  VListTileAction,
  VListTileActionText,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
  VTooltip,
})
